<template>
  <div>
    <v-container fluid class="pa-3 pa-sm-6">
      <v-card class="mx-auto elevation-12 home-card" max-width="1200" shaped>
        <v-card-text class="pa-4 pa-sm-8">
          <v-progress-linear
            v-if="cargandoInstitucion"
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-linear>

          <v-alert
            v-if="cargandoInstitucion"
            color="blue"
            dark
            outlined
            class="mb-4"
          >
            <v-icon left>mdi-loading mdi-spin</v-icon>
            Cargando datos del complejo...
          </v-alert>

          <GestionTurnos
            v-if="!cargandoInstitucion"
            ref="gestionTurnos"
            :idInstitucion="$store.state.idInstitucion"
            :idObraSocial="1"
            @turnoSeleccionado="abrirModalDatos"
          />
        </v-card-text>
      </v-card>
    </v-container>
    <ModalDatosPaciente
      v-if="showModalDatos"
      :visible="showModalDatos"
      :turnoSeleccionado="turnoSeleccionado"
      :idProfesional="idCanchaSeleccionada"
      @close="showModalDatos = false"
      @turnoGuardado="turnoGuardado"
    />
  </div>
</template>

<style scoped>
.home-card {
  width: 100%;
}

/* Responsive para móviles */
@media (max-width: 600px) {
  .home-card {
    border-radius: 8px !important;
  }
}

/* Ajustes para pantallas muy pequeñas */
@media (max-width: 360px) {
  .home-card {
    margin: 0 !important;
    border-radius: 0 !important;
  }
}
</style>

<script>
import axios from "../axios-auth.js";
import GestionTurnos from "../components/GestionTurnos.vue";
import ModalDatosPaciente from "../components/ModalDatosPaciente.vue";

export default {
  name: "Home",
  components: {
    GestionTurnos,
    ModalDatosPaciente,
  },
  props: {
    urlInstitucion: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      turnoSeleccionado: null,
      idCanchaSeleccionada: 0,
      showModalDatos: false,
      cargandoInstitucion: false,
    };
  },
  mounted() {
    this.inicializarInstitucion();
  },
  methods: {
    async inicializarInstitucion() {
      if (this.urlInstitucion) {
        this.cargandoInstitucion = true;
        this.$store.commit("setUrlInstitucion", this.urlInstitucion);

        try {
          const response = await axios.get("/Login/GetDatosInstitucion", {
            params: {
              urlInstitucion: this.urlInstitucion,
            },
          });

          this.$store.commit("setIdInstitucion", response.data.idInstitucion);
          this.$store.commit(
            "setNombreInstitucion",
            response.data.nombreInstitucion,
          );
          this.$store.commit("setUrlInstitucion", response.data.urlInstitucion);
          this.$store.commit("setEsEmpresa", response.data.esEmpresa);
        } catch (error) {
          console.error("Error al cargar datos de institución:", error);
          this.$swal.fire({
            icon: "error",
            title: "La institución no existe",
            text: "Por favor verifique la URL",
            showConfirmButton: true,
          });
          this.$router.push("/");
        } finally {
          this.cargandoInstitucion = false;
        }
      } else {
        this.cargandoInstitucion = false;
      }
    },
    abrirModalDatos(data) {
      this.turnoSeleccionado = data.turno;
      this.idCanchaSeleccionada = data.idCancha;
      this.showModalDatos = true;
    },
    turnoGuardado() {
      this.showModalDatos = false;
      this.turnoSeleccionado = null;
      this.idCanchaSeleccionada = 0;

      // Recargar los turnos según la vista activa
      if (this.$refs.gestionTurnos) {
        const gt = this.$refs.gestionTurnos;
        const vista = gt.vistaActual;
        if (vista === "semanal") gt.cargarTurnos();
        else if (vista === "diaria") gt.cargarTurnosDiarios();
        else if (vista === "completa") gt.cargarTurnosCompletos();
        else if (vista === "porDia") gt.cargarTurnosPorDia();
      }
    },
  },
};
</script>
